export { basicOrUndefined } from './adType';
